module.exports = __webpack_public_path__ + "img/RDecurion64_ua.6ef68309.webp";